import React, { useState, useEffect, useRef } from "react";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { handleGetRequest } from "../../../services/GetTemplate";
import { handlePostRequest } from "../../../services/PostTemplate";
import classNames from "classnames";
import SecuredFileChange from "../../../components/SecuredFileChange/SecuredFileChange";
import { Dialog } from "primereact";
import { Carousel } from "primereact/carousel";
import { MultiSelect } from "primereact/multiselect";
import { InputTextarea } from "primereact/inputtextarea";
import { endPoints } from "../../../Config";

const AddParts = ({ onHide, getPartList }) => {
    const [dimension, setDimension] = useState([]);
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [variant, setVariant] = useState([]);
    const [selectedFileError, setSelectedFileError] = useState(null);
    const [selectedFileArray, setSelectedFileArray] = useState([]);
    const [currencies, setCurrencies] = useState([]);
    const [displayImageDialog, setDisplayImageDialog] = useState(false);
    const [shippingData, setShippingData] = useState([]);
    const [brandData, setBrandData] = useState([]);
    const [conditionData, setConditionData] = useState([]);

    const partImageRef = useRef(null);
    const dispatch = useDispatch();

    const validationSchema = Yup.object().shape({
        skuNo: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, "Leading and trailing space is not allowed")
            .max(8, "Part name must be at most 8 characters")
            .required("This field is required"),
        quantity: Yup.string()?.required("Quantity should be atleast 1"),
        partName: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, "Leading and trailing space is not allowed")
            .max(30, "Part name must be at most 30 characters")
            .required("This field is required"),
        cost: Yup.string()?.required("This field is required"),
        currencyCode: Yup.string()?.required("This field is required"),
        images: Yup.string().when([], {
            is: () => selectedFileArray.length === 0,
            then: Yup.string().required("You must upload at least one image"),
            otherwise: Yup.string(),
        }),
    });

    const formik = useFormik({
        validationSchema,
        initialValues: {
            skuNo: "",
            quantity: "1",
            partName: "",
            dimensionsId: "",
            shippingId: [],
            brand: "",
            description: "",
            condition: "",
            variantId: [],
            cost: "",
            currencyCode: "",
            images: "",
            videoLink: "",
            isActive: "",
        },

        onSubmit: async (data) => {
            setLoadingBtn(true);
            let obj = {
                skuNo: data?.skuNo,
                quantity: parseInt(data?.quantity),
                partName: data?.partName,
                partId: data?.partId,
                condition: data?.condition,
                shippingId: data?.shippingId,
                brand: data?.brand,
                description: data?.description,
                dimensionsId: data?.dimensionsId ? data?.dimensionsId?.toString() : "",
                variantId: data?.variantId ? data?.variantId : undefined,
                cost: data?.cost ? data?.cost : "",
                videoLink: data?.videoLink ? data?.videoLink : "",
                currencyCode: data?.currencyCode ? data?.currencyCode?.toString() : undefined,
                images: selectedFileArray ? selectedFileArray : null,
            };
            const response = await dispatch(handlePostRequest(obj, endPoints.addPart, false, true));
            if (response?.statusCode === 200) {
                await getPartList();
                onHide();
            }
            setLoadingBtn(false);
        },
    });

    const getDimension = async () => {
        const response = await dispatch(handleGetRequest(endPoints.getallDimensions, false));
        if (response) {
            setDimension(response?.data);
        }
    };

    const getVariant = async () => {
        const response = await dispatch(handleGetRequest(endPoints.getVariantsDropdown, false));
        if (response) {
            setVariant(response?.data);
        }
    };

    const getCurrencies = async () => {
        const response = await dispatch(handleGetRequest(endPoints.getCurrenciesDropdown, false));
        if (response?.statusCode == 200) {
            setCurrencies(response?.data);
            console.log("first", response.data);
        }
    };

    const getShipping = async () => {
        const response = await dispatch(handleGetRequest(endPoints.getallShipments, false));
        if (response?.statusCode == 200) {
            setShippingData(response?.data);
        }
    };

    const getBrand = async () => {
        const response = await dispatch(handleGetRequest(endPoints.getallBrands, false));
        if (response?.statusCode == 200) {
            setBrandData(response?.data);
        }
    };
    const getConditions = async () => {
        const response = await dispatch(handleGetRequest(endPoints.getallConditions, false));
        if (response?.statusCode == 200) {
            setConditionData(response?.data);
        }
    };

    useEffect(() => {
        getDimension();
        getVariant();
        getCurrencies();
        getShipping();
        getBrand();
        getConditions();
    }, []);

    const previewImage = () => {
        setDisplayImageDialog(true);
    };

    const closeDisplayDialog = () => {
        setDisplayImageDialog(false);
    };

    const imagePreviewer = (file) => {
        return (
            <div className="p-field col-12 md:col-12">
                <img src={file} style={{ maxWidth: "100%", maxHeight: "100%", width: "900px", height: "500px", objectFit: "contain" }} />
            </div>
        );
    };

    const responsiveOptions = [
        {
            breakpoint: "1024px",
            numVisible: 3,
            numScroll: 3,
        },
    ];

    const handleDeleteImage = (index) => {
        setSelectedFileArray((prevFiles) => prevFiles.filter((_, i) => i !== index));
    };

    const handlePartIcon = () => {
        partImageRef.current.click();
    };

    // for multiple image upload
    function handlePartImageChange(event) {
        setSelectedFileError("");
        if (selectedFileArray?.length >= 6) {
            setSelectedFileError("You can only upload a maximum of 6 images.");
            return;
        }
        const selectedFile = event.target.files[0];
        const fileTypes = ["image", "mp4", ""];
        const { file: newFile, error } = SecuredFileChange(selectedFile, fileTypes);
        if (error) {
            setSelectedFileError(error);
        } else if (newFile) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result;
                setSelectedFileArray((prevItems) => [...prevItems, base64String]);
            };
            reader.readAsDataURL(newFile);
        }
    }

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    console.log("formmik", formik.errors);

    return (
        <>
            <Dialog visible={displayImageDialog} blockScroll style={{ width: "50vw" }} maskClassName="zindex9999" onHide={() => closeDisplayDialog()} draggable={false}>
                {selectedFileArray.length > 1 ? (
                    <Carousel value={selectedFileArray || []} numVisible={1} numScroll={1} responsiveOptions={responsiveOptions} className="custom-carousel" circular={false} itemTemplate={imagePreviewer} />
                ) : (
                    <img src={selectedFileArray[0]} style={{ maxWidth: "100%", maxHeight: "100%", width: "900px", height: "500px", objectFit: "contain" }} />
                )}
            </Dialog>

            <form onSubmit={formik.handleSubmit}>
                <div className="p-fluid formgrid grid pl-2 pr-2">
                    <div className="field col-12 md:col-6">
                        <label> Part Name </label>
                        <span className="Label__Required">*</span>
                        <InputText className={classNames({ "p-invalid": isFormFieldValid("partName") }, "Input__Round")} id="partName" name="partName" type="text" maxLength={30} value={formik.values.partName} onChange={formik.handleChange} placeholder="Enter Part Name" />
                        {getFormErrorMessage("partName")}
                    </div>

                    <div className="field col-12 md:col-6">
                        <label> SKU Number </label>
                        <span className="Label__Required">*</span>
                        <InputText className={classNames({ "p-invalid": isFormFieldValid("skuNo") }, "Input__Round")} id="skuNo" name="skuNo" type="text" maxLength={25} value={formik.values.skuNo} onChange={formik.handleChange} placeholder="Enter SKU Number" />
                        {getFormErrorMessage("skuNo")}
                    </div>
                    <div className="field col-12 md:col-6">
                        <label> Quantity </label>
                        <span className="Label__Required">*</span>
                        <InputText
                            keyfilter={/^[0-9]*(\.[0-9]*)?$/}
                            className={classNames({ "p-invalid": isFormFieldValid("quantity") }, "Input__Round")}
                            id="quantity"
                            name="quantity"
                            type="text"
                            maxLength={7}
                            value={formik.values.quantity}
                            onChange={formik.handleChange}
                            placeholder="Enter Quantity"
                        />
                        {getFormErrorMessage("quantity")}
                    </div>
                    <div className="field col-12 md:col-6">
                        <label>Variant</label>
                        <span className="Label__Required"></span>
                        <MultiSelect
                            display="chip"
                            className={classNames({ "p-invalid": isFormFieldValid("variantId") }, "Dropdown__Round Multiselect__Dropdown")}
                            id="variantId"
                            name="variantId"
                            options={variant}
                            optionValue="id"
                            optionLabel="name"
                            filter
                            showClear={!!formik?.values?.variantId}
                            filterBy="variantName"
                            showFilterClear={true}
                            resetFilterOnHide={true}
                            onChange={(e) => {
                                formik?.setFieldValue("variantId", e.target.value ? e.target.value : "");
                            }}
                            value={formik.values.variantId}
                            placeholder="Select"
                        />
                        {getFormErrorMessage("variantId")}
                    </div>

                    <div className="field col-12 md:col-6">
                        <label> Dimensions </label>
                        <span className="Label__Required"></span>
                        <Dropdown
                            className={classNames({ "p-invalid": isFormFieldValid("dimensionsId") }, "Dropdown__Round")}
                            id="dimensionsId"
                            name="dimensionsId"
                            options={dimension}
                            optionValue="id"
                            optionLabel="name"
                            filter
                            showClear={!!formik?.values?.dimensionsId}
                            filterBy="name"
                            showFilterClear={true}
                            resetFilterOnHide={true}
                            onChange={(e) => {
                                formik?.setFieldValue("dimensionsId", e.target.value ? e.target.value : "");
                            }}
                            value={formik.values.dimensionsId}
                            placeholder="Select"
                        />
                        {getFormErrorMessage("dimensionsId")}
                    </div>
                    <div className="flex field resp-column col-12 md:col-6">
                        <div className="field col-12 md:col-6 ">
                            <label> Price </label>
                            <span className="Label__Required">*</span>
                            <InputText keyfilter={/^[0-9]*(\.[0-9]*)?$/} className={classNames({ "p-invalid": isFormFieldValid("cost") }, "Input__Round")} id="cost" maxLength={8} name="cost" type="text" value={formik.values.cost} onChange={formik.handleChange} placeholder="Enter Price" />
                            {getFormErrorMessage("cost")}
                        </div>
                        <div className="field col-12 md:col-6 ml-0">
                            <label> Currency </label>
                            <span className="Label__Required">*</span>
                            <Dropdown
                                placeholder="Select currency"
                                className={classNames({ "p-invalid": isFormFieldValid("currencyCode") }, "Dropdown__Round")}
                                id="currencyCode"
                                name="currencyCode"
                                options={currencies}
                                optionValue="name"
                                optionLabel="name"
                                value={formik.values.currencyCode}
                                filter
                                showClear={!!formik?.values?.currencyCode}
                                filterBy="name"
                                showFilterClear={true}
                                resetFilterOnHide={true}
                                onChange={(e) => {
                                    formik?.setFieldValue("currencyCode", e.target.value ? e.target.value : "");
                                }}
                            />
                            {getFormErrorMessage("currencyCode")}
                        </div>
                    </div>
                    <div className="field col-12 md:col-6">
                        <label> Shipping </label>
                        <span className="Label__Required"></span>
                        <MultiSelect
                            display="chip"
                            className={classNames({ "p-invalid": isFormFieldValid("shippingId") }, "Dropdown__Round")}
                            id="shippingId"
                            name="shippingId"
                            options={shippingData}
                            optionValue="id"
                            optionLabel="name"
                            filter
                            showClear={!!formik?.values?.shippingId}
                            filterBy="name"
                            showFilterClear={true}
                            resetFilterOnHide={true}
                            onChange={(e) => {
                                formik?.setFieldValue("shippingId", e.target.value ? e.target.value : "");
                            }}
                            value={formik.values.shippingId}
                            editable
                            placeholder="Select"
                        />
                        {getFormErrorMessage("shippingId")}
                    </div>
                    <div className="field col-12 md:col-6">
                        <label> Brand </label>
                        <span className="Label__Required"></span>
                        <Dropdown
                            className={classNames({ "p-invalid": isFormFieldValid("brand") }, "Dropdown__Round")}
                            id="brand"
                            name="brand"
                            options={brandData}
                            optionValue="id"
                            optionLabel="name"
                            filter
                            showClear={!!formik?.values?.brand}
                            filterBy="name"
                            showFilterClear={true}
                            resetFilterOnHide={true}
                            onChange={(e) => {
                                formik?.setFieldValue("brand", e.target.value ? e.target.value : "");
                            }}
                            value={formik.values.brand}
                            placeholder="Select"
                        />
                        {getFormErrorMessage("brand")}
                    </div>
                    <div className="field col-12 md:col-6">
                        <label> Condition </label>
                        <span className="Label__Required"></span>
                        <Dropdown
                            className={classNames({ "p-invalid": isFormFieldValid("condition") }, "Dropdown__Round")}
                            id="condition"
                            name="condition"
                            options={conditionData}
                            optionValue="name"
                            optionLabel="name"
                            filter
                            showClear={!!formik?.values?.condition}
                            filterBy="name"
                            showFilterClear={true}
                            resetFilterOnHide={true}
                            onChange={(e) => {
                                formik?.setFieldValue("condition", e.target.value ? e.target.value : "");
                            }}
                            value={formik.values.condition}
                            placeholder="Select"
                        />
                        {getFormErrorMessage("condition")}
                    </div>

                    <div className="field col-12 md:col-12">
                        <label> Description </label>
                        <InputTextarea rows={4} className={classNames({ "p-invalid": isFormFieldValid("description") }, "Input__Round")} id="description" name="description" type="text" value={formik.values.description} onChange={formik.handleChange} placeholder="Enter Description" />
                    </div>
                    <div className="field col-12 md:col-6">
                        <label> Upload Images</label> <span className="Label__Required">*</span>
                        <div className="file-input-container " onClick={handlePartIcon}>
                            <input type="file" accept="image/*" style={{ display: "none" }} ref={partImageRef} onChange={handlePartImageChange} disabled={selectedFileArray?.length >= 6} />
                            <input className={classNames({ "p-invalid": isFormFieldValid("images") }, "custom-file p-inputtext p-component Input__Round")} type="text" placeholder="Choose a file..." value={formik.values.images} readOnly disabled={selectedFileArray?.length >= 6} />
                            <span className="file-upload-icon">
                                <i className="pi pi-paperclip" />
                            </span>
                        </div>
                        {selectedFileError ? <small className="p-error">{selectedFileError}</small> : getFormErrorMessage("images")}
                    </div>
                    <div className="field col-12 md:col-12">
                        <div>
                            <label> Uploaded Images </label>
                        </div>
                        <div className=" border-solid border-900 border-2 border-round p-5 mt-2">
                            {selectedFileArray.map((item, index) => {
                                return (
                                    <div key={index} style={{ position: "relative", display: "inline-block", margin: "5px", width: "110px", height: "110px" }}>
                                        <i className="pi pi-times closingIcon" onClick={() => handleDeleteImage(index)} style={{ cursor: "pointer", position: "absolute", top: "0", right: "0" }} />
                                        <img
                                            src={item}
                                            style={{ width: "90px", height: "90px", objectFit: "contain" }}
                                            alt="Part Image"
                                            onClick={() => {
                                                previewImage();
                                            }}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div className="col-12 d-flex flex-row text-center mt-4 pb-2">
                        <Button className="Cancel-Button" label="Cancel" type="button" onClick={onHide} />
                        <Button className="Save-Button ml-2" label="Add" type="submit" loading={loadingBtn} />
                    </div>
                </div>
            </form>
        </>
    );
};

export default AddParts;
